import * as React from 'react'

const SvgAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.625 9.375v-5h-1.25v5h-5v1.25h5v5h1.25v-5h5v-1.25h-5z"
      fill="#163250"
    />
  </svg>
)

export default SvgAddIcon
